import { ReactNode } from 'react'

import type { ColorScheme } from '@hivewatch/dark'
import { Box } from '@hivewatch/dark'

interface FilterRowIProps {
  label: string
  colorScheme: ColorScheme
  children: ReactNode
}

/**
 * One flat Filter Row: a label above a full-width selection field. Matches
 * the label treatment the dark Select/TextInput/DatePicker render internally,
 * for fields (MultiSelectInput) that have no label-above slot of their own.
 */
export const FilterRow = ({
  label,
  colorScheme,
  children,
}: FilterRowIProps) => (
  <Box display='flex' flexDirection='column'>
    <Box
      as='span'
      color={colorScheme === 'light' ? 'light.text.primary' : 'text.primary'}
      pb='4px'
      textStyle='label'
    >
      {label}
    </Box>
    {children}
  </Box>
)
